<template>
    <div v-if="ready">
        <form
            class="form-horizontal"
            enctype="multipart/form-data"
            @submit.prevent="store"
            @keydown="form.errors.clear($event.target.name)"
            novalidate
            autocomplete="off"
        >
            <form-input :form="form" required name="name"/>

            <backend-select
                :error="form.errors.get('depends_on')"
                name="depends_on"
                :route="route('trajectory-projects.trajectories.milestones.index', {
                    trajectory_project: project.id,
                    trajectory: this.trajectory.id
                })"
                label="depends_on"
                :value="field('depends_on')"
                v-model="form.depends_on"
                return="id"
                :prefix-data-with="[
                    { id: 'start_of_trajectory', name: uLang('app.start_of_trajectory') },
                    { id: 'end_of_trajectory', name: uLang('app.end_of_trajectory') }
                ]"
                required
            />

            <form-input
                :form="form"
                type="number"
                name="lead_time_in_days"
                step="1"
                min="0"
                required
            />

            <backend-select v-model="form.lead_time_of"
                :error="form.errors.get('lead_time_of')"
                name="lead_time_of"
                label="lead_time_of"
                :route="route('trajectory-projects.trajectories.milestones.index', {
                    trajectory_project: project.id,
                    trajectory: this.trajectory.id
                })"
                :value="field('lead_time_of')"
                return="id"
                :prefix-data-with="[
                    { id: 'start_of_trajectory', name: uLang('app.start_of_trajectory') },
                    { id: 'end_of_trajectory', name: uLang('app.end_of_trajectory') }
                ]"
                required
            />

            <form-input
                :form="form"
                type="number"
                name="maximum_hours"
                step="1"
                min="0"
            />

            <form-textarea
                :form="form"
                name="description"
                rows="6"
            />

            <div class="form-group fr-absolute">
                <input :disabled="form.busy" type="submit" class="btn btn-brand"
                       :value="uLang('app.save')"/>
            </div>
        </form>
    </div>
</template>

<script>
    import Form from '~/Form/Form';
    import FormMixin from '~/mixins/form';
    import SuccessfullyStoredAlert from "~/Swals/SuccessfullyStoredAlert";
    import SuccessfullyUpdatedAlert from "~/Swals/SuccessfullyUpdatedAlert";

    export default {
        name: 'milestone-form',

        mixins: [FormMixin],

        props: {
            project: {
                type: Object,
                required: true,
            },
            trajectory: {
                type: Object,
                required: true,
            },
            id: {
                required: false,
            },
        },

        data() {
            return {
                entity: 'milestone',
                form: new Form({
                    name: '',
                    description: '',
                    depends_on: null,
                    lead_time_of: null,
                    maximum_hours: '',
                    lead_time_in_days: '',
                }),
                swal: false,
            };
        },

        created() {
            this.$on('afterStore', this.afterStore);
            this.$on('afterUpdate', this.afterUpdate);
        },

        methods: {
            show() {
                this.$router.push({ name: 'admin.trajectory_projects.trajectories.milestones.view', params: { projectId: this.project.id, trajectoryId: this.trajectory.id, id: this.id }})
            },

            afterStore(data) {
                new SuccessfullyStoredAlert({entity: this.lang('app.milestone')}).show()
                    .then((buttonPressed) => {
                        if (buttonPressed === 'create_another') {
                            // Form mixin clears fields already
                        } else if (buttonPressed === 'show') {
                            this.$router.push({name: 'admin.trajectory_projects.trajectories.milestones.view', params: {
                                    projectId: this.project.id,
                                    trajectoryId: this.trajectory.id,
                                    id: data.id,
                                }});
                        }
                    });
            },

            afterUpdate(data) {
                new SuccessfullyUpdatedAlert({entity: this.lang('app.milestone')}).show()
                    .then(() => {
                        this.$router.push({name: 'admin.trajectory_projects.trajectories.milestones.view', params: {
                                projectId: this.project.id,
                                trajectoryId: this.trajectory.id,
                                id: this.id,
                            }});
                    });
            },
        },
    };
</script>

<style lang="css" scoped>

</style>
